// import React, { useEffect, useState } from "react";
// import { deleteData, patchData, postData } from "../../Service/ApiMethod";
// import { SUBUSER, Make_Admin } from "../../Service/service";
// import BackBar from "../home/BackBar";
// import UpdateSubUser from "../home/component/UpdateSubUser";

// const Subuser = () => {
//   const [data, setData] = useState();
//   const [show, setShow] = useState();
//   const [username, setUsername] = useState();
//   const [firstname, setFirstname] = useState();
//   const [lastname, setLastname] = useState();
//   const [email, setEmail] = useState();
//   const [phone, setPhone] = useState();
//   const [password, setPassword] = useState();
//   const [confirmpassword, setConfirmpassword] = useState();
//   const [updateSubUser, setUpdateSubUser] = useState(false);
//   const [selectedData, setSelectedData] = useState();

//   let objItem = {
//     username: username,
//     first_name: firstname,
//     last_name: lastname,
//     email: email,
//     phone: phone,
//     password: password,
//     confirm_password: confirmpassword,
//   };
//   console.log(objItem);
//   // const getItem={
//   //            "id": "",
//   //           "username": "",
//   //           "first_name": "",
//   //           "last_name": "",
//   //           "email": "",
//   //           "phone": "",
//   //           "parent_id": "",
//   // }
//   // console.log("static", objItem);
//   // const handleClick = async () => {
//   //   await postData(objItem, subuser_url)
//   //     .then(res => res.json())

//   //     .then(data => {
//   //       try {

//   //         console.log("From Api", data);
//   //         const token = data?.data?.access;
//   //         localStorage.setItem(
//   //           "access token login", token,
//   //           "refresh token", data?.data?.refresh,
//   //           'login_Phone', data?.data?.user?.phone
//   //         );
//   const edit = (id) => {
//     const obj = {
//       subuser_id: 4,
//       username: username,
//       first_name: firstname,
//       last_name: lastname,
//       email: email,
//       phone: phone,
//       password: password,
//       confirm_password: confirmpassword,
//     };

//     patchData(obj, SUBUSER)
//       .then((response) => response.json())
//       .then((response) => {
//         console.log("EDIT", response);
//       });
//   };

//   function handleClick(e) {
//     fetch("https://dev.jobportalapi.atwpl.com/recruiter/subuser/", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer  ${localStorage.getItem("catzapp_token")}`,
//       },
//       body: JSON.stringify({ ...objItem }),
//     })
//       .then((response) => response.json())
//       .then((data) => {

//         setData(data.data)
//         getUserData()
//       });
//     // console.log();
//   }
//   const getUserData = ()=>{
//      fetch("https://dev.jobportalapi.atwpl.com/recruiter/subuser/", {
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer  ${localStorage.getItem("catzapp_token")}`,
//       },
//     })
//       .then((response) => response.json())
//       .then((response) => {
//         setShow(response.data)
//         console.log('show', show)
//       })
//       .catch((err) => console.log(err));
//   }

//   const  handleDelete = (id)=>{
//     const obj ={
//       subuser_id: id
//     }
//     deleteData(obj, SUBUSER)
//     .then(response=>response.json())
//     .then(data => {
//       console.log('deletedData', data.data)
//       getUserData()
//     })
//     .catch((err)=>{
//       console.log(err.message)
//     })
//   }

//   const  handleMakeAdmin = (id)=>{
//     const obj = {
//       subuser_id: id
//     }
//     postData(obj, Make_Admin)
//     .then(response => response.json())
//     .then(data => {
//       console.log('make admin', data.data)
//       getUserData()
//     })
//     .catch((err)=>{
//       console.log(err.message)
//     })
//   }

//   console.log('selectedData', selectedData)
//   useEffect(() => {
//     getUserData()
//   },[]);

//   //   async function postHandle() {
//   //     await fetch(
//   //       `https://staging.jobportalapi.atwpl.com/recruiter/subuser/`,
//   //       {
//   //         method: "PATCH",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //           Authorization: `Bearer  ${localStorage.getItem("catzapp_token")}`,
//   //         },
//   //         body: JSON.stringify({
//   //           subuser_id:4,
//   //           username:Nitin,
//   //           first_name:Sandeep,
//   //           last_name:Sandy,

//   //         }),
//   //       }
//   //     )
//   //       .then((response) => response.json())
//   //       .then((data) => console.log(data));

//   //     props.fetchData();
//   //   }
//   //   const message = (mes) => { Swal.fire(mes) }
//   //   const handupdate = () => {
//   //              postHandle();
//   //              props.closePopup();
//   //               if (selectedData === "") {
//   //      message('Please Fill Valid Category')
//   //      return
//   //    }
//   //    message('Update Category Successfully')

//   //  }

//   // const getSubuser=()=>{
//   //   getData()
//   // }
//   // console.log(show);
//   // async function postHandle() {
//   //   await fetch(
//   //     `https://staging.jobportalapi.atwpl.com/recruiter/subuser/`,
//   //     {
//   //       method: "PATCH",
//   //       headers: {
//   //         "Content-Type": "application/json",
//   //         Authorization: `Bearer  ${localStorage.getItem("token")}`,
//   //       },
//   //       body: JSON.stringify({
//   //         subuser_id:4,
//   //         username:Nitin,
//   //         first_name:Sandeep,
//   //         last_name:Sandy,

//   //       }),
//   //     }
//   //   )
//   //     .then((response) => response.json())
//   //     .then((data) => console.log(data));

//   // }

//   return (
//     <>
//       <BackBar title="Sub Users" /> 
//       {/* <div className="space-between d-flex my-3 horizontal-center">
//         <p className="text text-bold heading">Subusers</p>
//       </div> */}

//       <hr className="line m-0 mb-3" />
//       <div className="mb-3">
//         <div className="row">
//           {/* <div style={{width: "100%", height:"100%"}} > */}
//           {/* <InfiniteScroll  style={{width: "100%", height:"100%"}}> */}
//           <div
//             className="col-lg-4 col-md-4 col-sm-12 col-12 pl-0"
//             style={{ height: "calc((100vh - 78px - 76px)", overflow: "auto" }}
//           >
//             {show &&
//               show?.map((show, i) => {
//                 const userShow = (
//                   <>
//                     <div className="row sub-user-box horizontal-center pb-2" key={i}>
//                       <div className="col-2 px-0">
//                         <img src="./images/msg1.png" className="mr-0" alt="" />
//                       </div>

//                       <div className="col-7 pr-0" onChange={{}}>
//                         <div className="div">
//                           <p className="text">{show.username}</p>
//                           <p className="text">{show.first_name}</p>
//                           <p className="text">{show.last_name}</p>
//                           <p className="text">{show.email}</p>
//                           <p className="text">{show.phone}</p>
//                           {/* <p className="text">{show.password}</p>
//                           <p className="text">{show.confirm_password}</p> */}

//                           {/* <p className="profile">Last Seen: 01:23 am, 02/02/2021</p> */}
//                         </div>

//                         {/* <button className="view-notification">View Message</button> */}
//                       </div>

//                       <div
//                         className="col-3 px-0"
//                         style={{
//                           flexDirection: "column",
//                           display: "flex",
//                           alignItems: "end",
//                         }}
//                       >
//                         <p className=" horizontal-center">
//                           {/* <img
//                     src="./images/go-arrow.png"
//                     className="ms-4 h-100 ml-4"
//                     alt=""
//                   /> */}
//                           {/* <button type="button" class="btn btn-outline-info" onClick={() => {
//                   setID(row.id);
//                   setUpdateSubUser();
//                 }}>Edit</button> */}

//                           <>
//                           <div>
//                             <button 
//                               className="btn btn-sm btn-outline-success rounded-4 px-3 me-2 mb-2"
//                               onClick={() => {
//                                 setSelectedData(show);
//                                 // setData(show.subuser_id);
//                                 setUpdateSubUser(true);
//                               }}
//                             >
//                               <i className="fa-solid fa-pen-to-square"></i>
//                               Edit
//                             </button>
//                             <button
//                             // style={{background:'red', color:'white'}}
//                               className="btn btn-sm btn-danger rounded-4 px-3 me-2 mb-2"
//                               onClick={() => {
//                                 handleDelete(show?.id)
//                               }}
//                             >
//                               Delete
//                             </button>
//                             <button
//                             // style={{background:'red', color:'white'}}
//                               className="btn-warning rounded-4 px-3 me-2"
//                               onClick={() => {
//                                handleMakeAdmin(show?.id)
//                               }}
//                             >
//                               Make Admin
//                             </button>
//                             </div>
//                           </>
//                         </p>
//                       </div>
//                     </div>
//                     <hr className="line m-0" />
//                   </>
//                 );
//                 return userShow;
//               })}

//             {/* <div className="row sub-user-box horizontal-center pb-2">
//               <div className="col-2 px-0">
//                 <img src="./images/msg1.png" className="mr-0" alt="" />
//               </div>
//               <div className="col-7 pr-0">
//                 <div className="div">
//                   <p className="text">Sub User Name 1</p>
//                   <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
//                 </div>

//                 <button className="view-notification">View Message</button>
//               </div>
//               <div
//                 className="col-3 px-0"
//                 style={{
//                   flexDirection: "column",
//                   display: "flex",
//                   alignItems: "end",
//                 }}
//               >
//                 <p className=" horizontal-center">
//                   <img
//                     src="./images/go-arrow.png"
//                     className="ms-4 h-100 ml-4"
//                     alt=""
//                   />
//                 </p>
//               </div>
//             </div> */}
//             {/* <hr className="line m-0" /> */}

//             {/* <div className="row sub-user-box horizontal-center pb-2">
//               <div className="col-2 px-0">
//                 <img src="./images/msg1.png" className="mr-0" alt="" />
//               </div>
//               <div className="col-7 pr-0">
//                 <div className="div">
//                   <p className="text">Sub User Name 1</p>
//                   <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
//                 </div>

//                 <button className="view-notification">View Message</button>
//               </div>
//               <div
//                 className="col-3 px-0"
//                 style={{
//                   flexDirection: "column",
//                   display: "flex",
//                   alignItems: "end",
//                 }}
//               >
//                 <p className=" horizontal-center">
//                   <img
//                     src="./images/go-arrow.png"
//                     className="ms-4 h-100 ml-4"
//                     alt=""
//                   />
//                 </p>
//               </div>
//             </div> */}
//             {/* <hr className="line m-0" /> */}

//             {/* <div className="row sub-user-box horizontal-center pb-2">
//               <div className="col-2 px-0">
//                 <img src="./images/msg1.png" className="mr-0" alt="" />
//               </div>
//               <div className="col-7 pr-0">
//                 <div className="div">
//                   <p className="text">Sub User Name 1</p>
//                   <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
//                 </div>

//                 <button className="view-notification">View Message</button>
//               </div>
//               <div
//                 className="col-3 px-0"
//                 style={{
//                   flexDirection: "column",
//                   display: "flex",
//                   alignItems: "end",
//                 }}
//               >
//                 <p className=" horizontal-center">
//                   <img
//                     src="./images/go-arrow.png"
//                     className="ms-4 h-100 ml-4"
//                     alt=""
//                   />
//                 </p>
//               </div>
//             </div> */}
//             {/* <hr className="line m-0" /> */}

//             {/* <div className="row sub-user-box horizontal-center pb-2">
//               <div className="col-2 px-0">
//                 <img src="./images/msg1.png" className="mr-0" alt="" />
//               </div>
//               <div className="col-7 pr-0">
//                 <div className="div">
//                   <p className="text">Sub User Name 1</p>
//                   <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
//                 </div>

//                 <button className="view-notification">View Message</button>
//               </div>
//               <div
//                 className="col-3 px-0"
//                 style={{
//                   flexDirection: "column",
//                   display: "flex",
//                   alignItems: "end",
//                 }}
//               >
//                 <p className=" horizontal-center">
//                   <img
//                     src="./images/go-arrow.png"
//                     className="ms-4 h-100 ml-4"
//                     alt=""
//                   />
//                 </p>
//               </div>
//             </div> */}
//             <hr className="line m-0" />

//             {/* <div className="row sub-user-box horizontal-center pb-2">
//               <div className="col-2 px-0">
//                 <img src="./images/msg1.png" className="mr-0" alt="" />
//               </div>
//               <div className="col-7 pr-0">
//                 <div className="div">
//                   <p className="text">Sub User Name 1</p>
//                   <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
//                 </div>

//                 <button className="view-notification">View Message</button>
//               </div>
//               <div
//                 className="col-3 px-0"
//                 style={{
//                   flexDirection: "column",
//                   display: "flex",
//                   alignItems: "end",
//                 }}
//               >
//                 <p className=" horizontal-center">
//                   <img
//                     src="./images/go-arrow.png"
//                     className="ms-4 h-100 ml-4"
//                     alt=""
//                   />
//                 </p>
//               </div>
//             </div> */}
//           </div>
//           {/* </InfiniteScroll> */}
//           {/* </div> */}
//           <div className="col-lg-8 col-md-8 col-sm-12 col-12 right-side-create-subusers">
//             <p className="heading mb-4">Create New Subuser</p>
//             <div className="row">
//               <div className="col-lg-6 col-12">
//                 <input
//                   type="text"
//                   placeholder="Enter User Name *"
//                   className="input-text mb-2"
//                   value={username}
//                   onChange={(e) => setUsername(e.target.value)}
//                 />

//                 <input
//                   type="text"
//                   placeholder="Enter First name *"
//                   className="input-text mb-2"
//                   value={firstname}
//                   onChange={(e) => setFirstname(e.target.value)}
//                 />

//                 <input
//                   type="text"
//                   placeholder="Enter Last Name *"
//                   className="input-text mb-2"
//                   value={lastname}
//                   onChange={(e) => setLastname(e.target.value)}
//                 />

//                 <input
//                   type="email"
//                   placeholder="Enter email  *"
//                   className="input-text mb-2"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="col-lg-6 col-12">
//                 <input
//                   type="text"
//                   placeholder="Enter Mobile number *"
//                   className="input-text mb-2"
//                   onChange={(e) => setPhone(e.target.value)}
//                 />

//                 <input
//                   type="password"
//                   placeholder="Enter Password *"
//                   className="input-text mb-2"
//                   value={password}
//                   autocomplete="off"
//                   onChange={(e) => setPassword(e.target.value)}
//                 />

//                 <input
//                   type="text"
//                   placeholder="Confirm Password *"
//                   className="input-text mb-2"
//                   value={confirmpassword}
//                   onChange={(e) => setConfirmpassword(e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="flex-center my-3">
//               <button
//                 className="theme-btn px-5"
//                 onClick={(e) => handleClick(e)}
//               >
//                 Create Now
//               </button>
//             </div>
//           </div>
//         </div>

//         {updateSubUser ? (
//           <UpdateSubUser
//             data={selectedData}
//             editType={data}
//             id={data}
//             // fetchData={useState}
//             closePopup={() => {
//               setUpdateSubUser(false);
//             }}
//           />
//         ) : null}
//       </div>
//     </>
//   );
// };

// export default Subuser;

// -----------------New Code-----------------------------
import React, { useEffect, useState } from "react";
import { deleteData, getData, patchData, postData } from "../../Service/ApiMethod";
import { SUBUSER, Make_Admin, RECURITER_PROFILE } from "../../Service/service";
import BackBar from "../home/BackBar";
import UpdateSubUser from "../home/component/UpdateSubUser";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import Loader from "../login/Loader";
import { useNavigate } from "react-router-dom";
import { lang } from "../../lang";

const Subuser = () => {

  const { t } = useTranslation();
  const [ln,setLn] = useState('en')

  const [data, setData] = useState([]);
  const [show, setShow] = useState([]);
  const [username, setUsername] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [updateSubUser, setUpdateSubUser] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [showPassword, setShowPassword] = useState(false)
  const [showPasswords, setShowPasswords] = useState(false)
  const [countryCode, setCountryCode] = useState('')
  const [status, setStatus] = useState('')
  const [popup, setPopup] = useState(false)
  const [checkNumber,setChecknumber] = useState("")
  const navigate = useNavigate()



  let objItem = {
    username: username,
    country_code: `+${countryCode}`,
    first_name: firstname,
    last_name: lastname,
    email: email,
    phone: checkNumber.charAt(0) === '0' ? "+"+countryCode+ checkNumber.slice(1) :"+"+countryCode+ checkNumber,
    password: password,
    confirm_password: confirmpassword,
  };
  console.log(objItem, 'object');

  // const edit = (id) => {
  //   const obj = {
  //     subuser_id: 4,
  //     username: username,
  //     first_name: firstname,
  //     last_name: lastname,
  //     email: email,
  //     phone: `+${phone}`,
  //     password: password,
  //     confirm_password: confirmpassword,
  //   };

  //   patchData(obj, SUBUSER)
  //     .then((response) => response.json())
  //     .then((response) => {
  //       console.log("EDIT", response);
  //     });
  // };

  const validpassword = (pass) => {
    return pass.match(
      // /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
    );
  }
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const [loaderStart, setLoaderstart] = useState(false)

  const validPhoneNumber = (phoneNumber) => {
    return /^[1-9][0-9]*$/.test(phoneNumber);
};




  function handleClick(e) {
    setLoaderstart(true)
    if (!username) {
      alert('UserName Required')
      setLoaderstart(false)
    } else if (!firstname) {
      alert('FirstName Required')
      setLoaderstart(false)
    } else if (!lastname) {
      alert('LastName Required')
      setLoaderstart(false)
    } else if (!email) {
      alert('Email Required')
      setLoaderstart(false)
    }else if (!emailPattern.test(email)) {
      alert('Enter Valid Email')
      setLoaderstart(false)
    } else if (!phone) {
      alert('Phone number Required')
      setLoaderstart(false)
    } 
    // else if (!validPhoneNumber(checkNumber)) {
    //   alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Enter Valid Mobile Number"] : "")
    //   setLoaderstart(false)
    // }
    else if (!password) {
      alert('Password Required')
      setLoaderstart(false)
    }else if(!validpassword(password)){
      alert("Please enter a password with at least 8 characters, including uppercase, lowercase, digits, and any special characters(@$!%*#?&)");
      setLoaderstart(false)
    }
     else if (!confirmpassword) {
      alert('Confirm Password Required')
      setLoaderstart(false)
    } else if (password !== confirmpassword) {
      alert("password and confirm password doesnot match")
      setLoaderstart(false)
    } else {
      console.log("okkkkkkkssa",objItem);
      postData(objItem, SUBUSER)
        .then((response) => response.json())
        .then((data) => {
          setLoaderstart(false)
          console.log("sssaazzzzzz",data);
          setStatus(data?.status_code)
          if (data?.status_code == 200) {
            setData(data?.data)
            setTimeout(() => {
              getUserData()
            }, 1000)
            console.log(data?.data, "postdata")
            alert(data?.message, "chekcjhs")
            setUsername('')
            setFirstname('')
            setLastname('')
            setPassword('')
            setConfirmpassword('')
            setPhone('')
            setEmail('')
          } else {
            console.log(data, "postdata top")
            alert(data?.error_message, 'something want wrong')
          }
          // else if (data?.error_message) {
          //   alert(data?.error_message ? data?.error_message : data?.error_message?.username[0])
          // }

        });
    }

  }
  const getUserData = () => {

    getData(SUBUSER)
      .then((response) => response.json())
      .then((response) => {
        setShow((response?.data)?.reverse())
        console.log(response, "resppppppp")
        console.log('show', show)
      })
      .catch((err) => {
        console.log(err)

      });

  }


  useEffect(() => {
    getUserData()
    profiles()
  }, [])

  useEffect(() => {
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    getUserData()
    profiles()
  }, [popup])

  const handleDelete = (id) => {
    const obj = {
      subuser_id: id
    }
    deleteData(obj, SUBUSER)
      .then(response => response.json())
      .then(data => {
        console.log('deletedData', data.data)

        alert(data?.message)
        setTimeout(() => {
          getUserData()
        }, 1000)

      })
      .catch((err) => {
        console.log(err.message)
      })
  }

  const handleMakeAdmin = (id) => {
    const obj = {
      subuser_id: id
    }
    postData(obj, Make_Admin)
      .then(response => response.json())
      .then(data => {
        console.log('make admin', data.data)
        alert(data?.message)
        setTimeout(() => {
          getUserData()
          navigate("/home");
        }, 1000)
      })
      .catch((err) => {
        console.log(err.message)
      })
  }

  console.log('selectedData', selectedData)


const [showForm, setShowform] = useState(false)
  const profiles =()=>{
    getData(RECURITER_PROFILE)
    .then((response) => response.json())
    .then((res) => {
    
      console.log('Main Profile Data', res.data.is_subuser)
      setShowform(res.data.is_subuser)
    })
    .catch((err) => {
      console.log("Error in categories from Post Form", err);
      console.log(" code Error", err);
    });
  }













  // useEffect(() => {
  //   getUserData()
  // },[]);
  // useEffect(() => {
  //   getUserData()
  // },[data]);

  //   async function postHandle() {
  //     await fetch(
  //       `https://staging.jobportalapi.atwpl.com/recruiter/subuser/`,
  //       {
  //         method: "PATCH",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer  ${localStorage.getItem("catzapp_token")}`,
  //         },
  //         body: JSON.stringify({
  //           subuser_id:4,
  //           username:Nitin,
  //           first_name:Sandeep,
  //           last_name:Sandy,

  //         }),
  //       }
  //     )
  //       .then((response) => response.json())
  //       .then((data) => console.log(data));

  //     props.fetchData();
  //   }
  //   const message = (mes) => { Swal.fire(mes) }
  //   const handupdate = () => {
  //              postHandle();
  //              props.closePopup();
  //               if (selectedData === "") {
  //      message('Please Fill Valid Category')
  //      return
  //    }
  //    message('Update Category Successfully')

  //  }

  // const getSubuser=()=>{
  //   getData()
  // }
  // console.log(show);
  // async function postHandle() {
  //   await fetch(
  //     `https://staging.jobportalapi.atwpl.com/recruiter/subuser/`,
  //     {
  //       method: "PATCH",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer  ${localStorage.getItem("token")}`,
  //       },
  //       body: JSON.stringify({
  //         subuser_id:4,
  //         username:Nitin,
  //         first_name:Sandeep,
  //         last_name:Sandy,

  //       }),
  //     }
  //   )
  //     .then((response) => response.json())
  //     .then((data) => console.log(data));

  // }

  return (
    <>
      <BackBar title={t("Sub Users")} /> 
      {/* <div className="space-between d-flex my-3 horizontal-center">
        <p className="text text-bold heading">Subusers</p>
      </div> */}
{
    loaderStart == true ? (<Loader/>):null
   }
      <hr className="line m-0 mb-3" />
      <div className="mb-3">
        <div className="row">
          {/* <div style={{width: "100%", height:"100%"}} > */}
          {/* <InfiniteScroll  style={{width: "100%", height:"100%"}}> */}
          <div
            className="col-lg-4 col-md-12 col-sm-12 col-12 pl-0 subUser-section"
            style={{}}
          >
            {show?.length != 0 ?
              show?.map((show, i) => {
                const userShow = (
                  <>
                    <div className="row sub-user-box horizontal-center pb-2" key={i}>
                      <div className="col-md-2 col-12 px-0">
                        <img src="./images/Vector.png" className="mr-0" style={{ width: '40px', height: '40px', borderRadius: '50%' }} alt="" />
                      </div>

                      <div className="col-md-6 col-12 pr-0" >
                        <div className="div">
                          <p className="text">{show?.username.length < 15 ?show?.username:show?.username.substring(0, 15)+"..."}</p>
                          <p className="text">{show?.first_name.length < 15 ?show?.first_name:show?.first_name.substring(0, 15)+"..."}</p>
                          <p className="text">{show?.last_name.length < 15 ?show?.last_name:show?.last_name.substring(0, 15)+"..."}</p>
                          <p className="text">{show?.email.length < 15 ?show?.email:show?.email.substring(0, 15)+"..."}</p>
                          <p className="text">{show?.phone.length < 15 ?show?.phone:show?.phone.substring(0, 15)+"..."}</p>
                          {/* <p className="text">{show.password}</p>
                          <p className="text">{show.confirm_password}</p> */}

                          {/* <p className="profile">Last Seen: 01:23 am, 02/02/2021</p> */}
                        </div>

                        {/* <button className="view-notification">View Message</button> */}
                      </div>

                      <div
                        className="col-md-4 col-12 px-0 last-btn"
                        style={{
                          flexDirection: "column",
                          display: "flex"

                        }}
                      >
                        <p className=" horizontal-center btns-outer">
                          {/* <img
                    src="./images/go-arrow.png"
                    className="ms-4 h-100 ml-4"
                    alt=""
                  /> */}
                          {/* <button type="button" class="btn btn-outline-info" onClick={() => {
                  setID(row.id);
                  setUpdateSubUser();
                }}>Edit</button> */}

                          <>
                            <div>
                              <button
                                className="btn btn-sm btn-outline-success px-3 me-2 mb-md-2"
                                onClick={() => {
                                  setSelectedData(show);
                                  // setData(show.subuser_id);
                                  setUpdateSubUser(true);
                                }}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                                {t('Edit')}
                              </button>
                              <button
                                // style={{background:'red', color:'white'}}
                                className="btn btn-sm btn-danger  px-3 me-2 mb-md-2"
                                onClick={() => {
                                  handleDelete(show?.id)
                                }}
                              >
                                {t('Delete')}
                              </button>
                              {/* <button
                                // style={{background:'red', color:'white'}}
                                className="btn-warning   me-2"
                                onClick={() => {
                                  handleMakeAdmin(show?.id)
                                }}
                              >
                                {t('Make Admin')}
                              </button> */}
                            </div>
                          </>
                        </p>
                      </div>
                    </div>
                    <hr className="line m-0" />
                  </>
                );
                return userShow;
              }) : ''}

            {/* <div className="row sub-user-box horizontal-center pb-2">
              <div className="col-2 px-0">
                <img src="./images/msg1.png" className="mr-0" alt="" />
              </div>
              <div className="col-7 pr-0">
                <div className="div">
                  <p className="text">Sub User Name 1</p>
                  <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
                </div>

                <button className="view-notification">View Message</button>
              </div>
              <div
                className="col-3 px-0"
                style={{
                  flexDirection: "column",
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <p className=" horizontal-center">
                  <img
                    src="./images/go-arrow.png"
                    className="ms-4 h-100 ml-4"
                    alt=""
                  />
                </p>
              </div>
            </div> */}
            {/* <hr className="line m-0" /> */}

            {/* <div className="row sub-user-box horizontal-center pb-2">
              <div className="col-2 px-0">
                <img src="./images/msg1.png" className="mr-0" alt="" />
              </div>
              <div className="col-7 pr-0">
                <div className="div">
                  <p className="text">Sub User Name 1</p>
                  <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
                </div>

                <button className="view-notification">View Message</button>
              </div>
              <div
                className="col-3 px-0"
                style={{
                  flexDirection: "column",
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <p className=" horizontal-center">
                  <img
                    src="./images/go-arrow.png"
                    className="ms-4 h-100 ml-4"
                    alt=""
                  />
                </p>
              </div>
            </div> */}
            {/* <hr className="line m-0" /> */}

            {/* <div className="row sub-user-box horizontal-center pb-2">
              <div className="col-2 px-0">
                <img src="./images/msg1.png" className="mr-0" alt="" />
              </div>
              <div className="col-7 pr-0">
                <div className="div">
                  <p className="text">Sub User Name 1</p>
                  <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
                </div>

                <button className="view-notification">View Message</button>
              </div>
              <div
                className="col-3 px-0"
                style={{
                  flexDirection: "column",
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <p className=" horizontal-center">
                  <img
                    src="./images/go-arrow.png"
                    className="ms-4 h-100 ml-4"
                    alt=""
                  />
                </p>
              </div>
            </div> */}
            {/* <hr className="line m-0" /> */}

            {/* <div className="row sub-user-box horizontal-center pb-2">
              <div className="col-2 px-0">
                <img src="./images/msg1.png" className="mr-0" alt="" />
              </div>
              <div className="col-7 pr-0">
                <div className="div">
                  <p className="text">Sub User Name 1</p>
                  <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
                </div>

                <button className="view-notification">View Message</button>
              </div>
              <div
                className="col-3 px-0"
                style={{
                  flexDirection: "column",
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <p className=" horizontal-center">
                  <img
                    src="./images/go-arrow.png"
                    className="ms-4 h-100 ml-4"
                    alt=""
                  />
                </p>
              </div>
            </div> */}
            <hr className="line m-0" />

            {/* <div className="row sub-user-box horizontal-center pb-2">
              <div className="col-2 px-0">
                <img src="./images/msg1.png" className="mr-0" alt="" />
              </div>
              <div className="col-7 pr-0">
                <div className="div">
                  <p className="text">Sub User Name 1</p>
                  <p className="profile">Last Seen: 01:23 am, 02/02/2021</p>
                </div>

                <button className="view-notification">View Message</button>
              </div>
              <div
                className="col-3 px-0"
                style={{
                  flexDirection: "column",
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <p className=" horizontal-center">
                  <img
                    src="./images/go-arrow.png"
                    className="ms-4 h-100 ml-4"
                    alt=""
                  />
                </p>
              </div>
            </div> */}
          </div>
          {/* </InfiniteScroll> */}
          {/* </div> */}
{
  showForm == false ? ( <div className="col-lg-8 col-md-8 col-sm-12 col-12 right-side-create-subusers">
  <p className="heading mb-4">{t('Create New Subuser')}</p>
  <div className="row">
    <div className="col-lg-6 col-12">
      <input
        type="text"
        placeholder={t("Enter User Name *")}
        className="input-text mb-2"
        value={username}
        onChange={(e) =>{ 
          if (!e.target.value.includes(' ')) {
            setUsername(e.target.value)
          } else {
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Space are not allowed"]:"");
          }
        }
        }
      />

      <input
        type="text"
        placeholder={t("Enter First Name *")}
        className="input-text mb-2"
        value={firstname}
        onChange={(e) => setFirstname(e.target.value)}
      />

      <input
        type="text"
        placeholder={t("Enter Last Name *")}
        className="input-text mb-2"
        value={lastname}
        onChange={(e) => setLastname(e.target.value)}
      />

      <input
        type="email"
        placeholder={t("Enter Email Address *")}
        className="input-text mb-2"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
    </div>
    <div className="col-lg-6 col-12 ">
      <div className="input-container ">
        <PhoneInput className="phone-inpt" inputStyle={{ width: '100%', fontSize: '17px', border: '1px solid #d2d2d2', height: '43px', width: '100%' }}
          placeholder={t("Enter Mobile Number *")}
          inputClassName='reactphoneinput'
          type='text'
          // className="input-text mb-2"
          country={"in"}
          enableSearch={true}
          
          // onChange={(e) => setPhone(e.target.value)}
          // defaultValue='+91'
          onChange={(phone, selectedCountry) => {
            const phoneNumberWithoutCode = phone.replace(selectedCountry.dialCode, '');
            console.log(phoneNumberWithoutCode,"ow")
            setChecknumber(phoneNumberWithoutCode)
            setPhone(phone)
            setCountryCode(selectedCountry.dialCode)
          }}
          name=''
          id='phone'
        />
        {/* <input
        type="text"
        placeholder="Enter Mobile number *"
        className="input-text mb-2"
        onChange={(e) => setPhone(e.target.value)}
      /> */}
      </div>

      <input
        // type="password"
        placeholder={t("Enter Password *")}
        className="input-text my-2"
        value={password}
        // autocomplete="off"
        type={showPassword ? 'text' : "password"}
        onChange={(e) => setPassword(e.target.value)}
      />
      <span onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer', position: 'absolute', right: '25px', top: '65px' }} >
        {showPassword ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
      </span>

      <input
        // type="text"
        placeholder={t("Confirm Password *")}
        className="input-text mb-2"
        value={confirmpassword}
        type={showPasswords ? 'text' : "password"}
        // autocomplete="off"
        onChange={(e) => setConfirmpassword(e.target.value)}
      />
      <span onClick={() => setShowPasswords(!showPasswords)} style={{ cursor: 'pointer', position: 'absolute', right: '25px', top: '117px' }} >
        {showPasswords ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
      </span>
    </div>
  </div>
  <div className="flex-center my-3">
    <button
      className="theme-btn px-5"
      onClick={(e) => handleClick(e)}
    >
      {t('Create Sub User')}
    </button>
  </div>
</div>):null
}
         
        </div>

        {updateSubUser ? (
          <UpdateSubUser
            data={selectedData}
            setPopup={setPopup}
            // fetchData={useState}
            closePopup={() => {
              setUpdateSubUser(false);
            }}
          />
        ) : null}
      </div>
    </>
  );
};

export default Subuser
// -----------------New Code End-----------------------------

